module.exports = __webpack_public_path__ + "static/img/41.17ec26a.png";